var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4085 2.01904C20.3112 2.01904 16.5483 6.47301 13.8868 9.13449C11.0757 11.9455 6.92142 14.9599 4.95461 18.3316C4.00842 19.9536 1.92676 21.782 1.92676 19.2021C1.92676 15.5705 2.94969 10.743 4.50043 7.46917C5.43542 5.49532 6.01436 2.90798 6.01436 6.48512C6.01436 9.69277 5.51067 12.4502 4.27334 15.4551C1.93708 21.1289 5.1321 19.0089 8.89081 20.2618C11.3525 21.0824 12.9263 21.7758 15.5521 21.7758",
    stroke: "#28C9C1",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopArrow);
export default __webpack_public_path__ + "static/media/top-arrow.6d2f3856df3559081c829282ee2ff807.svg";
export { ForwardRef as ReactComponent };